export default __webpack_public_path__ + "static/8-3a2879bd5057645f7ed615bd127d1474.jpg";